import React from 'react';
import { renderRoutes } from 'react-router-config';
import ReactGA from 'react-ga';

import 'semantic-ui-css/semantic.css';

import ScrollToTop from '../../components/ScrollToTop';
import './App.css';
import routes from '../../routes';
import config from '../../config';
import { preventCustomDomainAccess } from '../../helpers/customDomainsHelper';

ReactGA.initialize(config.googleAnalyticsId, {
  debug: !(process.env.REACT_APP_ENV === 'production')
});

preventCustomDomainAccess();

const App = () => <ScrollToTop>{renderRoutes(routes)}</ScrollToTop>;

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js